import { apiClient } from '@/lib/api/api-client'

import type {
  ActivateTrialDto,
  OrganizationSubscription,
  StartTrialDto,
  SubscriptionPlan,
} from '@scrambl/shared'

export interface TrialActivationSession {
  sessionId: string
  url: string
  /** True when the remaining trial days are kept and billing starts at trial end. */
  preservesTrial: boolean
  billingStartsAt: string
}

const organizationPath = (organizationId: string) =>
  `/subscriptions/organizations/${encodeURIComponent(organizationId)}`

/** No-card trials (docs/PLAN-no-card-trials.md). */
export const trialApi = {
  plans: async (): Promise<SubscriptionPlan[]> =>
    (await apiClient<{ data: SubscriptionPlan[] }>('/subscriptions/plans'))
      .data ?? [],
  start: async (
    organizationId: string,
    body: StartTrialDto,
  ): Promise<OrganizationSubscription> =>
    (
      await apiClient<{ data: OrganizationSubscription }>(
        `${organizationPath(organizationId)}/trial`,
        { method: 'POST', body },
      )
    ).data,
  activate: async (
    organizationId: string,
    body: ActivateTrialDto,
  ): Promise<TrialActivationSession> =>
    (
      await apiClient<{ data: TrialActivationSession }>(
        `${organizationPath(organizationId)}/trial/activate`,
        { method: 'POST', body },
      )
    ).data,
}
